import { T19 } from "./CustomerGroupSalesWithGrowth/T19";
import { T02 } from "./SalesByChannelLastYearVSActual/T02";

export const AgentGrowthPerformance = {
  "sections": [
    T19,
    T02
  ]
}